import React from 'react';
import PropTypes from 'prop-types';

import { IconChevronRight, Text } from '@zillow/constellation';
import { Col, Row } from '@zillow/zrs-comet';

import { Container, Header, SecondaryText } from './StyledComponents';

const propTypes = {
    addBorderBottom: PropTypes.bool,
    cta: PropTypes.node,
    ctaIcon: PropTypes.bool,
    icon: PropTypes.node.isRequired,
    onHeaderClick: PropTypes.func,
    primaryText: PropTypes.string.isRequired,
    secondaryText: PropTypes.string.isRequired,
};

const defaultProps = {
    addBorderBottom: false,
    cta: null,
    ctaIcon: true,
    onHeaderClick: null,
};

const ListCell = ({
    addBorderBottom,
    cta,
    ctaIcon,
    icon,
    onHeaderClick,
    primaryText,
    secondaryText,
}) => (
    <Container className="ListCell" borderBottom={addBorderBottom}>
        <Row>
            <Header
                style={{
                    cursor: onHeaderClick ? 'pointer' : 'inherit',
                }}
                onClick={onHeaderClick}
            >
                <Col xs={2} alignVertical="center" alignHorizontal="center">{icon}</Col>
                <Col xs={8} noPadding={true}>
                    <Text as="b">{primaryText}</Text>
                    <SecondaryText fontType="bodySmall">{secondaryText}</SecondaryText>
                </Col>
                <Col xs={2} alignVertical="center" alignHorizontal="center">
                    {ctaIcon && (
                        <IconChevronRight
                            fontColor="brand"
                            size="sm"
                        />
                    )}
                </Col>
            </Header>
        </Row>
        <Row>
            <Col xs={2} />
            <Col xs={8} noPadding={true}>
                {cta}
            </Col>
            <Col xs={2} />
        </Row>
    </Container>
);

ListCell.propTypes = propTypes;
ListCell.defaultProps = defaultProps;

export default ListCell;
